import * as Focus from '../common/focus';
import domReady from '@wordpress/dom-ready';

function initPopupComponent() {
  const popup = document.querySelector('#site-popup');

  if (!popup) return;

  const closeButton = popup.querySelector('.popup__close-button');

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/`;
  }

  function showPopup() {
    popup.classList.add('visible');

    setTimeout(() => {
      closeButton.focus();
      Focus.trapFocusInside(jQuery('#site-popup'));
    }, 300);
  }

  function closePopup() {
    popup.classList.remove('visible');
    Focus.untrapFocusInside(jQuery('#site-popup'));
    setCookie('popupClosed', 'true', 1); // Cookie expires in 1 day
  }

  const popupClosed = getCookie('popupClosed') === 'true';

  if (!popupClosed) {
    setTimeout(() => {
      showPopup();
    }, 300);
  }

  closeButton?.addEventListener('click', () => {
    closePopup();
  });

  document.addEventListener('keydown', (event) => {
    if ('Escape' === event.key && popup.classList.contains('visible')) {
      closePopup();
    }
  });
}

domReady(() => {
  initPopupComponent();
});
